"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NATIVE_LANGUAGE_NAMES = exports.LOCALE_BROWSER_MAP = exports.ConsentManagerLanguageKey = exports.CONSENT_MANAGER_SUPPORTED_LOCALES = exports.LOCALE_TRANSLATION_MAP = exports.TRANSCEND_SUPPORTED_TRANSLATIONS = exports.AWS_SUPPORTED_TRANSLATIONS = exports.LOCALE_KEY = exports.LanguageKey = void 0;
/* eslint-disable max-lines */
// TODO: Remove old object here once dependencies are switched to LOCALE_KEY
/**
 * The language identifier keys
 *
 * @see https://en.wikipedia.org/wiki/List-of-ISO-639-1-codes
 */
var LanguageKey;
(function (LanguageKey) {
    /** English */
    LanguageKey["En"] = "en";
    /** Arabic */
    LanguageKey["Ar"] = "ar";
    /** French */
    LanguageKey["Fr"] = "fr";
    /** Spanish */
    LanguageKey["Es"] = "es";
    /** German */
    LanguageKey["De"] = "de";
    /** Italian */
    LanguageKey["It"] = "it";
    /** Japanese */
    LanguageKey["Ja"] = "ja";
    /** Russian */
    LanguageKey["Ru"] = "ru";
    /** Arabic UAE */
    LanguageKey["ArAe"] = "ar-AE";
    /** French */
    LanguageKey["FrFr"] = "fr-FR";
    /** German */
    LanguageKey["DeDe"] = "de-DE";
    /** Austrian German */
    LanguageKey["DeAt"] = "de-AT";
    /** Swiss German */
    LanguageKey["DeCh"] = "de-CH";
    /** Italian */
    LanguageKey["ItIt"] = "it-IT";
    /** Swiss Italian */
    LanguageKey["ItCh"] = "it-CH";
    /** Afrikaans */
    LanguageKey["AfZz"] = "af-ZA";
    /** Bulgarian */
    LanguageKey["BgBg"] = "bg-BG";
    /** Chinese Simplified */
    LanguageKey["ZhCn"] = "zh-CN";
    /** Croatian */
    LanguageKey["HrHr"] = "hr-HR";
    /** Czech */
    LanguageKey["CsCz"] = "cs-CZ";
    /** Danish */
    LanguageKey["DaDk"] = "da-DK";
    /** English UK */
    LanguageKey["EnGb"] = "en-GB";
    /** English CA */
    LanguageKey["EnCa"] = "en-CA";
    /** English UAE */
    LanguageKey["EnAe"] = "en-AE";
    /** Finnish */
    LanguageKey["FiFi"] = "fi-FI";
    /** Greek */
    LanguageKey["ElGr"] = "el-GR";
    /** Hindi */
    LanguageKey["HiIn"] = "hi-IN";
    /** Hungarian */
    LanguageKey["HuHu"] = "hu-HU";
    /** Indonesian */
    LanguageKey["IdId"] = "id-ID";
    /** Japanese */
    LanguageKey["JaJp"] = "ja-JP";
    /** Korean */
    LanguageKey["KoKr"] = "ko-KR";
    /** Lithuanian */
    LanguageKey["LtLt"] = "lt-LT";
    /** Malay */
    LanguageKey["MsMy"] = "ms-MY";
    /** Marathi */
    LanguageKey["MrIn"] = "mr-IN";
    /** Norwegian Bokmål */
    LanguageKey["NbNi"] = "nb-NO";
    /** Polish */
    LanguageKey["PlPl"] = "pl-PL";
    /** Portuguese (Brazil) */
    LanguageKey["PtBr"] = "pt-BR";
    /** Portuguese (Portugal) */
    LanguageKey["PtPt"] = "pt-PT";
    /** Romanian */
    LanguageKey["RoRo"] = "ro-RO";
    /** Russian */
    LanguageKey["RuRu"] = "ru-RU";
    /** Serbian (Latin) */
    LanguageKey["SrLatnRs"] = "sr-Latn-RS";
    /** Swedish */
    LanguageKey["SvSe"] = "sv-SE";
    /** Tamil */
    LanguageKey["TaIn"] = "ta-IN";
    /** Thai */
    LanguageKey["ThTh"] = "th-TH";
    /** Turkish */
    LanguageKey["TrTr"] = "tr-TR";
    /** Ukrainian */
    LanguageKey["UkUa"] = "uk-UA";
    /** Vietnamese */
    LanguageKey["ViVn"] = "vi-VN";
    /** Zulu */
    LanguageKey["ZuZa"] = "zu-ZA";
    /** USA */
    LanguageKey["EnUs"] = "en-US";
    /** Australia */
    LanguageKey["EnAu"] = "en-AU";
    /** Belgium */
    LanguageKey["FrBe"] = "fr-BE";
    /** Quebec */
    LanguageKey["FrCa"] = "fr-CA";
    /** French (Switzerland) */
    LanguageKey["FrCh"] = "fr-CH";
    /** Ireland */
    LanguageKey["EnIe"] = "en-IE";
    /** Dutch */
    LanguageKey["NlNl"] = "nl-NL";
    /** Dutch (Belgium) */
    LanguageKey["NlBe"] = "nl-BE";
    /** Spanish (Castellano) */
    LanguageKey["EsEs"] = "es-ES";
    /** Spanish (Latin America & Caribbean) */
    LanguageKey["Es419"] = "es-419";
    /** Chinese (Traditional) */
    LanguageKey["ZhHk"] = "zh-HK";
    /** Hebrew (Israel) */
    LanguageKey["HeIl"] = "he-IL";
    /** English (New Zealand) */
    LanguageKey["EnNz"] = "en-NZ";
    /** Estonian (Estonia) */
    LanguageKey["EtEe"] = "et-EE";
    /** Icelandic (Iceland) */
    LanguageKey["IsIs"] = "is-IS";
    /** Latvian (Latvia) */
    LanguageKey["LvLv"] = "lv-LV";
    /** Maltese (Malta) */
    LanguageKey["MtMt"] = "mt-MT";
    /** Slovak (Slovakia) */
    LanguageKey["SkSk"] = "sk-SK";
    /** Slovenian (Slovenia) */
    LanguageKey["SlSl"] = "sl-SL";
})(LanguageKey = exports.LanguageKey || (exports.LanguageKey = {}));
/**
 * The locale identifier keys
 *
 * @see https://en.wikipedia.org/wiki/List-of-ISO-639-1-codes
 */
exports.LOCALE_KEY = {
    /** English */
    En: 'en',
    /** Arabic */
    Ar: 'ar',
    /** French */
    Fr: 'fr',
    /** Spanish */
    Es: 'es',
    /** German */
    De: 'de',
    /** Italian */
    It: 'it',
    /** Japanese */
    Ja: 'ja',
    /** Russian */
    Ru: 'ru',
    /** Arabic UAE */
    ArAe: 'ar-AE',
    /** French */
    FrFr: 'fr-FR',
    /** German */
    DeDe: 'de-DE',
    /** Austrian German */
    DeAt: 'de-AT',
    /** Swiss German */
    DeCh: 'de-CH',
    /** Italian */
    ItIt: 'it-IT',
    /** Swiss Italian */
    ItCh: 'it-CH',
    /** Afrikaans */
    AfZz: 'af-ZA',
    /** Bulgarian */
    BgBg: 'bg-BG',
    /** Chinese Simplified */
    ZhCn: 'zh-CN',
    /** Croatian */
    HrHr: 'hr-HR',
    /** Czech */
    CsCz: 'cs-CZ',
    /** Danish */
    DaDk: 'da-DK',
    /** English UK */
    EnGb: 'en-GB',
    /** English CA */
    EnCa: 'en-CA',
    /** English UAE */
    EnAe: 'en-AE',
    /** Finnish */
    FiFi: 'fi-FI',
    /** Greek */
    ElGr: 'el-GR',
    /** Hindi */
    HiIn: 'hi-IN',
    /** Hungarian */
    HuHu: 'hu-HU',
    /** Indonesian */
    IdId: 'id-ID',
    /** Japanese */
    JaJp: 'ja-JP',
    /** Korean */
    KoKr: 'ko-KR',
    /** Lithuanian */
    LtLt: 'lt-LT',
    /** Malay */
    MsMy: 'ms-MY',
    /** Marathi */
    MrIn: 'mr-IN',
    /** Norwegian Bokmål */
    NbNi: 'nb-NO',
    /** Polish */
    PlPl: 'pl-PL',
    /** Portuguese (Brazil) */
    PtBr: 'pt-BR',
    /** Portuguese (Portugal) */
    PtPt: 'pt-PT',
    /** Romanian */
    RoRo: 'ro-RO',
    /** Russian */
    RuRu: 'ru-RU',
    /** Serbian (Latin) */
    SrLatnRs: 'sr-Latn-RS',
    /** Swedish */
    SvSe: 'sv-SE',
    /** Tamil */
    TaIn: 'ta-IN',
    /** Thai */
    ThTh: 'th-TH',
    /** Turkish */
    TrTr: 'tr-TR',
    /** Ukrainian */
    UkUa: 'uk-UA',
    /** Vietnamese */
    ViVn: 'vi-VN',
    /** Zulu */
    ZuZa: 'zu-ZA',
    /** USA */
    EnUs: 'en-US',
    /** Australia */
    EnAu: 'en-AU',
    /** Belgium */
    FrBe: 'fr-BE',
    /** Quebec */
    FrCa: 'fr-CA',
    /** French (Switzerland) */
    FrCh: 'fr-CH',
    /** Ireland */
    EnIe: 'en-IE',
    /** Dutch */
    NlNl: 'nl-NL',
    /** Dutch (Belgium) */
    NlBe: 'nl-BE',
    /** Spanish (Castellano) */
    EsEs: 'es-ES',
    /** Spanish (Latin America & Caribbean) */
    Es419: 'es-419',
    /** Chinese (Traditional) */
    ZhHk: 'zh-HK',
    /** Hebrew (Israel) */
    HeIl: 'he-IL',
    /** English (New Zealand) */
    EnNz: 'en-NZ',
    /** Estonian (Estonia) */
    EtEe: 'et-EE',
    /** Icelandic (Iceland) */
    IsIs: 'is-IS',
    /** Latvian (Latvia) */
    LvLv: 'lv-LV',
    /** Maltese (Malta) */
    MtMt: 'mt-MT',
    /** Slovak (Slovakia) */
    SkSk: 'sk-SK',
    /** Slovenian (Slovenia) */
    SlSl: 'sl-SL',
};
/**
 * List of AWS supported translations, see: https://docs.aws.amazon.com/translate/latest/dg/what-is-languages.html#what-is-languages-supported
 */
exports.AWS_SUPPORTED_TRANSLATIONS = {
    Afrikaans: 'af',
    Albanian: 'sq',
    Amharic: 'am',
    Arabic: 'ar',
    Armenian: 'hy',
    Azerbaijani: 'az',
    Bengali: 'bn',
    Bosnian: 'bs',
    Bulgarian: 'bg',
    Catalan: 'ca',
    ChineseSimplified: 'zh',
    ChineseTraditional: 'zh-TW',
    Croatian: 'hr',
    Czech: 'cs',
    Danish: 'da',
    Dari: 'fa-AF',
    Dutch: 'nl',
    English: 'en',
    Estonian: 'et',
    Farsi: 'fa',
    Tagalog: 'tl',
    Finnish: 'fi',
    French: 'fr',
    FrenchCanada: 'fr-CA',
    Georgian: 'ka',
    German: 'de',
    Greek: 'el',
    Gujarati: 'gu',
    HaitianCreole: 'ht',
    Hausa: 'ha',
    Hebrew: 'he',
    Hindi: 'hi',
    Hungarian: 'hu',
    Icelandic: 'is',
    Indonesian: 'id',
    Irish: 'ga',
    Italian: 'it',
    Japanese: 'ja',
    Kannada: 'kn',
    Kazakh: 'kk',
    Korean: 'ko',
    Latvian: 'lv',
    Lithuanian: 'lt',
    Macedonian: 'mk',
    Malay: 'ms',
    Malayalam: 'ml',
    Maltese: 'mt',
    Marathi: 'mr',
    Mongolian: 'mn',
    Norwegian: 'no',
    Pashto: 'ps',
    Polish: 'pl',
    PortugueseBrazil: 'pt',
    PortuguesePortugal: 'pt-PT',
    Punjabi: 'pa',
    Romanian: 'ro',
    Russian: 'ru',
    Serbian: 'sr',
    Sinhala: 'si',
    Slovak: 'sk',
    Slovenian: 'sl',
    Somali: 'so',
    Spanish: 'es',
    SpanishMexico: 'es-MX',
    Swahili: 'sw',
    Swedish: 'sv',
    Tamil: 'ta',
    Telugu: 'te',
    Thai: 'th',
    Turkish: 'tr',
    Ukrainian: 'uk',
    Urdu: 'ur',
    Uzbek: 'uz',
    Vietnamese: 'vi',
    Welsh: 'cy',
};
/** These are the languages we could translate with AWS but don't currently */
const TRANSCEND_UNSUPPORTED_TRANSLATIONS = [
    'Albanian',
    'Amharic',
    'Armenian',
    'Azerbaijani',
    'Bengali',
    'Bosnian',
    'Catalan',
    'Dari',
    'Tagalog',
    // 'FrenchCanada', originally not supported but im fixing this
    'Georgian',
    'Gujarati',
    'HaitianCreole',
    'Hausa',
    'Irish',
    'Kannada',
    'Kazakh',
    'Macedonian',
    'Malayalam',
    'Mongolian',
    'Pashto',
    'Punjabi',
    'Sinhala',
    'Somali',
    'Swahili',
    'Telugu',
    'Urdu',
    'Uzbek',
    'Welsh',
];
exports.TRANSCEND_SUPPORTED_TRANSLATIONS = Object.fromEntries(Object.entries(exports.AWS_SUPPORTED_TRANSLATIONS).filter(([key]) => !TRANSCEND_UNSUPPORTED_TRANSLATIONS.includes(key)));
/**
 * TODO:
 * We currently have a "duplicated" locale for base lang -> base lang - base region.
 * Do we want to exclude "German - Germany" and just have "Germany"?
 */
/** Mapping of Locale to AWS Translation */
exports.LOCALE_TRANSLATION_MAP = {
    [exports.LOCALE_KEY.En]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.English,
    [exports.LOCALE_KEY.Ar]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Arabic,
    [exports.LOCALE_KEY.Fr]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.French,
    [exports.LOCALE_KEY.Es]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Spanish,
    [exports.LOCALE_KEY.De]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.German,
    [exports.LOCALE_KEY.It]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Italian,
    [exports.LOCALE_KEY.Ja]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Japanese,
    [exports.LOCALE_KEY.Ru]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Russian,
    [exports.LOCALE_KEY.ArAe]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Arabic,
    [exports.LOCALE_KEY.FrFr]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.French,
    [exports.LOCALE_KEY.DeDe]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.German,
    [exports.LOCALE_KEY.DeAt]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.German,
    [exports.LOCALE_KEY.DeCh]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.German,
    [exports.LOCALE_KEY.ItIt]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Italian,
    [exports.LOCALE_KEY.ItCh]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Italian,
    [exports.LOCALE_KEY.AfZz]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Afrikaans,
    [exports.LOCALE_KEY.BgBg]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Bulgarian,
    [exports.LOCALE_KEY.ZhCn]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.ChineseSimplified,
    [exports.LOCALE_KEY.HrHr]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Croatian,
    [exports.LOCALE_KEY.CsCz]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Czech,
    [exports.LOCALE_KEY.DaDk]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Danish,
    [exports.LOCALE_KEY.EnGb]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.English,
    [exports.LOCALE_KEY.EnCa]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.English,
    [exports.LOCALE_KEY.EnAe]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.English,
    [exports.LOCALE_KEY.FiFi]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Finnish,
    [exports.LOCALE_KEY.ElGr]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Greek,
    [exports.LOCALE_KEY.HiIn]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Hindi,
    [exports.LOCALE_KEY.HuHu]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Hungarian,
    [exports.LOCALE_KEY.IdId]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Indonesian,
    [exports.LOCALE_KEY.JaJp]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Japanese,
    [exports.LOCALE_KEY.KoKr]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Korean,
    [exports.LOCALE_KEY.LtLt]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Lithuanian,
    [exports.LOCALE_KEY.MsMy]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Malay,
    [exports.LOCALE_KEY.MrIn]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Marathi,
    [exports.LOCALE_KEY.NbNi]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Norwegian,
    [exports.LOCALE_KEY.PlPl]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Polish,
    [exports.LOCALE_KEY.PtBr]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.PortugueseBrazil,
    [exports.LOCALE_KEY.PtPt]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.PortuguesePortugal,
    [exports.LOCALE_KEY.RoRo]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Romanian,
    [exports.LOCALE_KEY.RuRu]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Russian,
    [exports.LOCALE_KEY.SrLatnRs]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Serbian,
    [exports.LOCALE_KEY.SvSe]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Swedish,
    [exports.LOCALE_KEY.TaIn]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Tamil,
    [exports.LOCALE_KEY.ThTh]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Thai,
    [exports.LOCALE_KEY.TrTr]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Turkish,
    [exports.LOCALE_KEY.UkUa]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Ukrainian,
    [exports.LOCALE_KEY.ViVn]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Vietnamese,
    [exports.LOCALE_KEY.ZuZa]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.English,
    [exports.LOCALE_KEY.EnUs]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.English,
    [exports.LOCALE_KEY.EnAu]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.English,
    [exports.LOCALE_KEY.FrBe]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.French,
    [exports.LOCALE_KEY.FrCa]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.FrenchCanada,
    [exports.LOCALE_KEY.FrCh]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.French,
    [exports.LOCALE_KEY.EnIe]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.English,
    [exports.LOCALE_KEY.NlNl]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Dutch,
    [exports.LOCALE_KEY.NlBe]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Dutch,
    [exports.LOCALE_KEY.EsEs]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Spanish,
    [exports.LOCALE_KEY.Es419]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.SpanishMexico,
    [exports.LOCALE_KEY.ZhHk]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.ChineseTraditional,
    [exports.LOCALE_KEY.HeIl]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Hebrew,
    [exports.LOCALE_KEY.EnNz]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.English,
    [exports.LOCALE_KEY.EtEe]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Estonian,
    [exports.LOCALE_KEY.IsIs]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Icelandic,
    [exports.LOCALE_KEY.LvLv]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Latvian,
    [exports.LOCALE_KEY.MtMt]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Maltese,
    [exports.LOCALE_KEY.SkSk]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Slovak,
    [exports.LOCALE_KEY.SlSl]: exports.TRANSCEND_SUPPORTED_TRANSLATIONS.Slovenian,
};
/** These are the languages we have an enum value for but do not populate in the CM UI */
const CONSENT_MANAGER_UNSUPPORTED_LOCALES = [
    'Ar',
    'Fr',
    'Es',
    'De',
    'It',
    'Ja',
    'Ru',
    'DeAt',
    'DeCh',
    'ItCh',
    'EnGb',
    'EnCa',
    'EnAe',
    'PtPt',
    'ZuZa',
    'EnUs',
    'EnAu',
    'FrBe',
    'FrCa',
    'FrCh',
    'EnIe',
    'NlBe',
    'EnNz',
    'EtEe',
    'LvLv',
    'MtMt',
    'SkSk',
    'SlSl',
];
exports.CONSENT_MANAGER_SUPPORTED_LOCALES = Object.fromEntries(Object.entries(exports.LOCALE_KEY).filter(([key]) => !CONSENT_MANAGER_UNSUPPORTED_LOCALES.includes(key)));
// TODO: Remove old object here once dependencies are switched to CONSENT_MANAGER_SUPPORTED_LOCALES
exports.ConsentManagerLanguageKey = {
    En: LanguageKey.En,
    FrFr: LanguageKey.FrFr,
    DeDe: LanguageKey.DeDe,
    ItIt: LanguageKey.ItIt,
    PtBr: LanguageKey.PtBr,
    Es419: LanguageKey.Es419,
    EsEs: LanguageKey.EsEs,
    CsCz: LanguageKey.CsCz,
    DaDk: LanguageKey.DaDk,
    FiFi: LanguageKey.FiFi,
    ElGr: LanguageKey.ElGr,
    LtLt: LanguageKey.LtLt,
    NbNi: LanguageKey.NbNi,
    PlPl: LanguageKey.PlPl,
    RoRo: LanguageKey.RoRo,
    RuRu: LanguageKey.RuRu,
    SrLatnRs: LanguageKey.SrLatnRs,
    SvSe: LanguageKey.SvSe,
    ArAe: LanguageKey.ArAe,
    JaJp: LanguageKey.JaJp,
    KoKr: LanguageKey.KoKr,
    ZhCn: LanguageKey.ZhCn,
    ZhHk: LanguageKey.ZhHk,
    AfZz: LanguageKey.AfZz,
    BgBg: LanguageKey.BgBg,
    HrHr: LanguageKey.HrHr,
    HuHu: LanguageKey.HuHu,
    IdId: LanguageKey.IdId,
    MsMy: LanguageKey.MsMy,
    HiIn: LanguageKey.HiIn,
    MrIn: LanguageKey.MrIn,
    TaIn: LanguageKey.TaIn,
    ThTh: LanguageKey.ThTh,
    TrTr: LanguageKey.TrTr,
    UkUa: LanguageKey.UkUa,
    ViVn: LanguageKey.ViVn,
    NlNl: LanguageKey.NlNl,
    HeIl: LanguageKey.HeIl,
};
/**
 * List of BCP 47 language codes, grabbed from https://www.localeplanet.com/icu/
 *
 * anything commented and marked TO-DO is for languages that AWS supports but we do not
 * all other comments are to leave in those browser codes in case AWS updates to support them
 */
exports.LOCALE_BROWSER_MAP = {
    af: exports.LOCALE_KEY.AfZz,
    'af-NA': exports.LOCALE_KEY.AfZz,
    'af-ZA': exports.LOCALE_KEY.AfZz,
    // 'agq', // Aghem Aghem
    // 'agq-CM', // Aghem (Cameroon) Aghem (Kàmàlûŋ)
    // 'ak', // Akan Akan
    // 'ak-GH', // Akan (Ghana) Akan (Gaana)
    // 'am', // Amharic አማርኛ TODO
    // 'am-ET', // Amharic (Ethiopia) አማርኛ (ኢትዮጵያ) TODO
    ar: exports.LOCALE_KEY.Ar,
    'ar-001': exports.LOCALE_KEY.Ar,
    'ar-AE': exports.LOCALE_KEY.ArAe,
    'ar-BH': exports.LOCALE_KEY.Ar,
    'ar-DJ': exports.LOCALE_KEY.Ar,
    'ar-DZ': exports.LOCALE_KEY.Ar,
    'ar-EG': exports.LOCALE_KEY.Ar,
    'ar-EH': exports.LOCALE_KEY.Ar,
    'ar-ER': exports.LOCALE_KEY.Ar,
    'ar-IL': exports.LOCALE_KEY.Ar,
    'ar-IQ': exports.LOCALE_KEY.Ar,
    'ar-JO': exports.LOCALE_KEY.Ar,
    'ar-KM': exports.LOCALE_KEY.Ar,
    'ar-KW': exports.LOCALE_KEY.Ar,
    'ar-LB': exports.LOCALE_KEY.Ar,
    'ar-LY': exports.LOCALE_KEY.Ar,
    'ar-MA': exports.LOCALE_KEY.Ar,
    'ar-MR': exports.LOCALE_KEY.Ar,
    'ar-OM': exports.LOCALE_KEY.Ar,
    'ar-PS': exports.LOCALE_KEY.Ar,
    'ar-QA': exports.LOCALE_KEY.Ar,
    'ar-SA': exports.LOCALE_KEY.Ar,
    'ar-SD': exports.LOCALE_KEY.Ar,
    'ar-SO': exports.LOCALE_KEY.Ar,
    'ar-SS': exports.LOCALE_KEY.Ar,
    'ar-SY': exports.LOCALE_KEY.Ar,
    'ar-TD': exports.LOCALE_KEY.Ar,
    'ar-TN': exports.LOCALE_KEY.Ar,
    'ar-YE': exports.LOCALE_KEY.Ar,
    // 'as', // Assamese অসমীয়া
    // 'as-IN', // Assamese (India) অসমীয়া (ভারত)
    // 'asa', // Asu Kipare
    // 'asa-TZ', // Asu (Tanzania) Kipare (Tadhania)
    // 'ast', // Asturian asturianu
    // 'ast-ES', // Asturian (Spain) asturianu (España)
    // 'az', // Azerbaijani azərbaycan TODO
    // 'az-Cyrl', // Azerbaijani (Cyrillic) азәрбајҹан (Кирил) TODO
    // 'az-Cyrl-AZ', // Azerbaijani (Cyrillic, Azerbaijan) азәрбајҹан (Кирил, Азәрбајҹан) TODO
    // 'az-Latn', // Azerbaijani (Latin) azərbaycan (latın) TODO
    // 'az-Latn-AZ', // Azerbaijani (Latin, Azerbaijan) azərbaycan (latın, Azərbaycan) TODO
    // 'bas', // Basaa Ɓàsàa
    // 'bas-CM', // Basaa (Cameroon) Ɓàsàa (Kàmɛ̀rûn)
    // 'be', // Belarusian беларуская
    // 'be-BY', // Belarusian (Belarus) беларуская (Беларусь)
    // 'bem', // Bemba Ichibemba
    // 'bem-ZM', // Bemba (Zambia) Ichibemba (Zambia)
    // 'bez', // Bena Hibena
    // 'bez-TZ', // Bena (Tanzania) Hibena (Hutanzania)
    bg: exports.LOCALE_KEY.BgBg,
    'bg-BG': exports.LOCALE_KEY.BgBg,
    // 'bm', // Bambara bamanakan
    // 'bm-ML', // Bambara (Mali) bamanakan (Mali)
    // 'bn', // Bangla বাংলা
    // 'bn-BD', // Bangla (Bangladesh) বাংলা (বাংলাদেশ)
    // 'bn-IN', // Bangla (India) বাংলা (ভারত)
    // 'bo', // Tibetan བོད་སྐད་
    // 'bo-CN', // Tibetan (China) བོད་སྐད་ (རྒྱ་ནག)
    // 'bo-IN', // Tibetan (India) བོད་སྐད་ (རྒྱ་གར་)
    // 'br', // Breton brezhoneg
    // 'br-FR', // Breton (France) brezhoneg (Frañs)
    // 'brx', // Bodo बड़ो
    // 'brx-IN', // Bodo (India) बड़ो (भारत)
    // 'bs', // Bosnian bosanski TODO
    // 'bs-Cyrl', // Bosnian (Cyrillic) босански (ћирилица) TODO
    // 'bs-Cyrl-BA', // Bosnian (Cyrillic, Bosnia & Herzegovina) босански (ћирилица, Босна и Херцеговина) TODO
    // 'bs-Latn', // Bosnian (Latin) bosanski (latinica) TODO
    // 'bs-Latn-BA', // Bosnian (Latin, Bosnia & Herzegovina) bosanski (latinica, Bosna i Hercegovina) TODO
    // 'ca', // Catalan català TODO
    // 'ca-AD', // Catalan (Andorra) català (Andorra) TODO
    // 'ca-ES', // Catalan (Spain) català (Espanya) TODO
    // 'ca-FR', // Catalan (France) català (França) TODO
    // 'ca-IT', // Catalan (Italy) català (Itàlia) TODO
    // 'ccp', // Chakma 𑄌𑄋𑄴𑄟𑄳𑄦
    // 'ccp-BD', // Chakma (Bangladesh) 𑄌𑄋𑄴𑄟𑄳𑄦 (𑄝𑄁𑄣𑄘𑄬𑄌𑄴)
    // 'ccp-IN', // Chakma (India) 𑄌𑄋𑄴𑄟𑄳𑄦 (𑄞𑄢𑄧𑄖𑄴)
    // 'ce', // Chechen нохчийн
    // 'ce-RU', // Chechen (Russia) нохчийн (Росси)
    // 'cgg', // Chiga Rukiga
    // 'cgg-UG', // Chiga (Uganda) Rukiga (Uganda)
    // 'chr', // Cherokee ᏣᎳᎩ
    // 'chr-US', // Cherokee (United States) ᏣᎳᎩ (ᏌᏊ ᎢᏳᎾᎵᏍᏔᏅ ᏍᎦᏚᎩ)
    // 'ckb', // Central Kurdish کوردیی ناوەندی
    // 'ckb-IQ', // Central Kurdish (Iraq) کوردیی ناوەندی (عێراق)
    // 'ckb-IR', // Central Kurdish (Iran) کوردیی ناوەندی (ئێران)
    cs: exports.LOCALE_KEY.CsCz,
    'cs-CZ': exports.LOCALE_KEY.CsCz,
    // 'cy', // Welsh Cymraeg TODO
    // 'cy-GB', // Welsh (United Kingdom) Cymraeg (Y Deyrnas Unedig) TODO
    da: exports.LOCALE_KEY.DaDk,
    'da-DK': exports.LOCALE_KEY.DaDk,
    'da-GL': exports.LOCALE_KEY.DaDk,
    // 'dav', // Taita Kitaita
    // 'dav-KE', // Taita (Kenya) Kitaita (Kenya)
    de: exports.LOCALE_KEY.De,
    'de-AT': exports.LOCALE_KEY.DeAt,
    'de-BE': exports.LOCALE_KEY.De,
    'de-CH': exports.LOCALE_KEY.DeCh,
    'de-DE': exports.LOCALE_KEY.DeDe,
    'de-IT': exports.LOCALE_KEY.De,
    'de-LI': exports.LOCALE_KEY.De,
    'de-LU': exports.LOCALE_KEY.De,
    // 'dje', // Zarma Zarmaciine
    // 'dje-NE', // Zarma (Niger) Zarmaciine (Nižer)
    // 'dsb', // Lower Sorbian dolnoserbšćina
    // 'dsb-DE', // Lower Sorbian (Germany) dolnoserbšćina (Nimska)
    // 'dua', // Duala duálá
    // 'dua-CM', // Duala (Cameroon) duálá (Cameroun)
    // 'dyo', // Jola-Fonyi joola
    // 'dyo-SN', // Jola-Fonyi (Senegal) joola (Senegal)
    // 'dz', // Dzongkha རྫོང་ཁ
    // 'dz-BT', // Dzongkha (Bhutan) རྫོང་ཁ། (འབྲུག།)
    // 'ebu', // Embu Kĩembu
    // 'ebu-KE', // Embu (Kenya) Kĩembu (Kenya)
    // 'ee', // Ewe Eʋegbe
    // 'ee-GH', // Ewe (Ghana) Eʋegbe (Ghana nutome)
    // 'ee-TG', // Ewe (Togo) Eʋegbe (Togo nutome)
    el: exports.LOCALE_KEY.ElGr,
    'el-CY': exports.LOCALE_KEY.ElGr,
    'el-GR': exports.LOCALE_KEY.ElGr,
    en: exports.LOCALE_KEY.En,
    'en-001': exports.LOCALE_KEY.En,
    'en-150': exports.LOCALE_KEY.En,
    'en-AG': exports.LOCALE_KEY.En,
    'en-AI': exports.LOCALE_KEY.En,
    'en-AS': exports.LOCALE_KEY.En,
    'en-AT': exports.LOCALE_KEY.En,
    'en-AU': exports.LOCALE_KEY.EnAu,
    'en-BB': exports.LOCALE_KEY.En,
    'en-BE': exports.LOCALE_KEY.En,
    'en-BI': exports.LOCALE_KEY.En,
    'en-BM': exports.LOCALE_KEY.En,
    'en-BS': exports.LOCALE_KEY.En,
    'en-BW': exports.LOCALE_KEY.En,
    'en-BZ': exports.LOCALE_KEY.En,
    'en-CA': exports.LOCALE_KEY.En,
    'en-CC': exports.LOCALE_KEY.En,
    'en-CH': exports.LOCALE_KEY.En,
    'en-CK': exports.LOCALE_KEY.En,
    'en-CM': exports.LOCALE_KEY.En,
    'en-CX': exports.LOCALE_KEY.En,
    'en-CY': exports.LOCALE_KEY.En,
    'en-DE': exports.LOCALE_KEY.En,
    'en-DG': exports.LOCALE_KEY.En,
    'en-DK': exports.LOCALE_KEY.En,
    'en-DM': exports.LOCALE_KEY.En,
    'en-ER': exports.LOCALE_KEY.En,
    'en-FI': exports.LOCALE_KEY.En,
    'en-FJ': exports.LOCALE_KEY.En,
    'en-FK': exports.LOCALE_KEY.En,
    'en-FM': exports.LOCALE_KEY.En,
    'en-GB': exports.LOCALE_KEY.EnGb,
    'en-GD': exports.LOCALE_KEY.En,
    'en-GG': exports.LOCALE_KEY.En,
    'en-GH': exports.LOCALE_KEY.En,
    'en-GI': exports.LOCALE_KEY.En,
    'en-GM': exports.LOCALE_KEY.En,
    'en-GU': exports.LOCALE_KEY.En,
    'en-GY': exports.LOCALE_KEY.En,
    'en-HK': exports.LOCALE_KEY.En,
    'en-IE': exports.LOCALE_KEY.EnIe,
    'en-IL': exports.LOCALE_KEY.En,
    'en-IM': exports.LOCALE_KEY.En,
    'en-IN': exports.LOCALE_KEY.En,
    'en-IO': exports.LOCALE_KEY.En,
    'en-JE': exports.LOCALE_KEY.En,
    'en-JM': exports.LOCALE_KEY.En,
    'en-KE': exports.LOCALE_KEY.En,
    'en-KI': exports.LOCALE_KEY.En,
    'en-KN': exports.LOCALE_KEY.En,
    'en-KY': exports.LOCALE_KEY.En,
    'en-LC': exports.LOCALE_KEY.En,
    'en-LR': exports.LOCALE_KEY.En,
    'en-LS': exports.LOCALE_KEY.En,
    'en-MG': exports.LOCALE_KEY.En,
    'en-MH': exports.LOCALE_KEY.En,
    'en-MO': exports.LOCALE_KEY.En,
    'en-MP': exports.LOCALE_KEY.En,
    'en-MS': exports.LOCALE_KEY.En,
    'en-MT': exports.LOCALE_KEY.En,
    'en-MU': exports.LOCALE_KEY.En,
    'en-MW': exports.LOCALE_KEY.En,
    'en-MY': exports.LOCALE_KEY.En,
    'en-NA': exports.LOCALE_KEY.En,
    'en-NF': exports.LOCALE_KEY.En,
    'en-NG': exports.LOCALE_KEY.En,
    'en-NL': exports.LOCALE_KEY.En,
    'en-NR': exports.LOCALE_KEY.En,
    'en-NU': exports.LOCALE_KEY.En,
    'en-NZ': exports.LOCALE_KEY.EnNz,
    'en-PG': exports.LOCALE_KEY.En,
    'en-PH': exports.LOCALE_KEY.En,
    'en-PK': exports.LOCALE_KEY.En,
    'en-PN': exports.LOCALE_KEY.En,
    'en-PR': exports.LOCALE_KEY.En,
    'en-PW': exports.LOCALE_KEY.En,
    'en-RW': exports.LOCALE_KEY.En,
    'en-SB': exports.LOCALE_KEY.En,
    'en-SC': exports.LOCALE_KEY.En,
    'en-SD': exports.LOCALE_KEY.En,
    'en-SE': exports.LOCALE_KEY.En,
    'en-SG': exports.LOCALE_KEY.En,
    'en-SH': exports.LOCALE_KEY.En,
    'en-SI': exports.LOCALE_KEY.En,
    'en-SL': exports.LOCALE_KEY.En,
    'en-SS': exports.LOCALE_KEY.En,
    'en-SX': exports.LOCALE_KEY.En,
    'en-SZ': exports.LOCALE_KEY.En,
    'en-TC': exports.LOCALE_KEY.En,
    'en-TK': exports.LOCALE_KEY.En,
    'en-TO': exports.LOCALE_KEY.En,
    'en-TT': exports.LOCALE_KEY.En,
    'en-TV': exports.LOCALE_KEY.En,
    'en-TZ': exports.LOCALE_KEY.En,
    'en-UG': exports.LOCALE_KEY.En,
    'en-UM': exports.LOCALE_KEY.En,
    'en-US': exports.LOCALE_KEY.EnUs,
    'en-US-POSIX': exports.LOCALE_KEY.EnUs,
    'en-VC': exports.LOCALE_KEY.En,
    'en-VG': exports.LOCALE_KEY.En,
    'en-VI': exports.LOCALE_KEY.En,
    'en-VU': exports.LOCALE_KEY.En,
    'en-WS': exports.LOCALE_KEY.En,
    'en-ZA': exports.LOCALE_KEY.En,
    'en-ZM': exports.LOCALE_KEY.En,
    'en-ZW': exports.LOCALE_KEY.En,
    // 'eo', // Esperanto esperanto
    es: exports.LOCALE_KEY.Es,
    'es-419': exports.LOCALE_KEY.Es419,
    'es-AR': exports.LOCALE_KEY.Es419,
    'es-BO': exports.LOCALE_KEY.Es419,
    'es-BR': exports.LOCALE_KEY.Es419,
    'es-BZ': exports.LOCALE_KEY.Es419,
    'es-CL': exports.LOCALE_KEY.Es419,
    'es-CO': exports.LOCALE_KEY.Es419,
    'es-CR': exports.LOCALE_KEY.Es419,
    'es-CU': exports.LOCALE_KEY.Es419,
    'es-DO': exports.LOCALE_KEY.Es419,
    'es-EA': exports.LOCALE_KEY.Es419,
    'es-EC': exports.LOCALE_KEY.Es419,
    'es-ES': exports.LOCALE_KEY.EsEs,
    'es-GQ': exports.LOCALE_KEY.Es419,
    'es-GT': exports.LOCALE_KEY.Es419,
    'es-HN': exports.LOCALE_KEY.Es419,
    'es-IC': exports.LOCALE_KEY.Es419,
    'es-MX': exports.LOCALE_KEY.Es419,
    'es-NI': exports.LOCALE_KEY.Es419,
    'es-PA': exports.LOCALE_KEY.Es419,
    'es-PE': exports.LOCALE_KEY.Es419,
    'es-PH': exports.LOCALE_KEY.Es419,
    'es-PR': exports.LOCALE_KEY.Es419,
    'es-PY': exports.LOCALE_KEY.Es419,
    'es-SV': exports.LOCALE_KEY.Es419,
    'es-US': exports.LOCALE_KEY.Es419,
    'es-UY': exports.LOCALE_KEY.Es419,
    'es-VE': exports.LOCALE_KEY.Es419,
    et: exports.LOCALE_KEY.EtEe,
    'et-EE': exports.LOCALE_KEY.EtEe,
    // 'eu', // Basque euskara
    // 'eu-ES', // Basque (Spain) euskara (Espainia)
    // 'ewo', // Ewondo ewondo
    // 'ewo-CM', // Ewondo (Cameroon) ewondo (Kamərún)
    // 'fa', // Persian فارسی TODO
    // 'fa-AF', // Persian (Afghanistan) فارسی (افغانستان) Dari TODO
    // 'fa-IR', // Persian (Iran) فارسی (ایران) TODO
    // 'ff', // Fulah Pulaar
    // 'ff-CM', // Fulah (Cameroon) Pulaar (Kameruun)
    // 'ff-GN', // Fulah (Guinea) Pulaar (Gine)
    // 'ff-MR', // Fulah (Mauritania) Pulaar (Muritani)
    // 'ff-SN', // Fulah (Senegal) Pulaar (Senegaal)
    fi: exports.LOCALE_KEY.FiFi,
    'fi-FI': exports.LOCALE_KEY.FiFi,
    // 'fil', // Filipino Filipino TODO
    // 'fil-PH', // Filipino (Philippines) Filipino (Pilipinas) TODO
    // 'fo', // Faroese føroyskt
    // 'fo-DK', // Faroese (Denmark) føroyskt (Danmark)
    // 'fo-FO', // Faroese (Faroe Islands) føroyskt (Føroyar)
    fr: exports.LOCALE_KEY.Fr,
    'fr-BE': exports.LOCALE_KEY.FrBe,
    'fr-BF': exports.LOCALE_KEY.Fr,
    'fr-BI': exports.LOCALE_KEY.Fr,
    'fr-BJ': exports.LOCALE_KEY.Fr,
    'fr-BL': exports.LOCALE_KEY.Fr,
    'fr-CA': exports.LOCALE_KEY.FrCa,
    'fr-CD': exports.LOCALE_KEY.Fr,
    'fr-CF': exports.LOCALE_KEY.Fr,
    'fr-CG': exports.LOCALE_KEY.Fr,
    'fr-CH': exports.LOCALE_KEY.FrCh,
    'fr-CI': exports.LOCALE_KEY.Fr,
    'fr-CM': exports.LOCALE_KEY.Fr,
    'fr-DJ': exports.LOCALE_KEY.Fr,
    'fr-DZ': exports.LOCALE_KEY.Fr,
    'fr-FR': exports.LOCALE_KEY.FrFr,
    'fr-GA': exports.LOCALE_KEY.Fr,
    'fr-GF': exports.LOCALE_KEY.Fr,
    'fr-GN': exports.LOCALE_KEY.Fr,
    'fr-GP': exports.LOCALE_KEY.Fr,
    'fr-GQ': exports.LOCALE_KEY.Fr,
    'fr-HT': exports.LOCALE_KEY.Fr,
    'fr-KM': exports.LOCALE_KEY.Fr,
    'fr-LU': exports.LOCALE_KEY.Fr,
    'fr-MA': exports.LOCALE_KEY.Fr,
    'fr-MC': exports.LOCALE_KEY.Fr,
    'fr-MF': exports.LOCALE_KEY.Fr,
    'fr-MG': exports.LOCALE_KEY.Fr,
    'fr-ML': exports.LOCALE_KEY.Fr,
    'fr-MQ': exports.LOCALE_KEY.Fr,
    'fr-MR': exports.LOCALE_KEY.Fr,
    'fr-MU': exports.LOCALE_KEY.Fr,
    'fr-NC': exports.LOCALE_KEY.Fr,
    'fr-NE': exports.LOCALE_KEY.Fr,
    'fr-PF': exports.LOCALE_KEY.Fr,
    'fr-PM': exports.LOCALE_KEY.Fr,
    'fr-RE': exports.LOCALE_KEY.Fr,
    'fr-RW': exports.LOCALE_KEY.Fr,
    'fr-SC': exports.LOCALE_KEY.Fr,
    'fr-SN': exports.LOCALE_KEY.Fr,
    'fr-SY': exports.LOCALE_KEY.Fr,
    'fr-TD': exports.LOCALE_KEY.Fr,
    'fr-TG': exports.LOCALE_KEY.Fr,
    'fr-TN': exports.LOCALE_KEY.Fr,
    'fr-VU': exports.LOCALE_KEY.Fr,
    'fr-WF': exports.LOCALE_KEY.Fr,
    'fr-YT': exports.LOCALE_KEY.Fr,
    // 'fur', // Friulian furlan
    // 'fur-IT', // Friulian (Italy) furlan (Italie)
    // 'fy', // Western Frisian Fryskx
    // 'fy-NL', // Western Frisian (Netherlands) Frysk (Nederlân)
    // 'ga', // Irish Gaeilge TODO
    // 'ga-IE', // Irish (Ireland) Gaeilge (Éire) TODO
    // 'gd', // Scottish Gaelic Gàidhlig
    // 'gd-GB', // Scottish Gaelic (United Kingdom) Gàidhlig (An Rìoghachd Aonaichte)
    // 'gl', // Galician galego
    // 'gl-ES', // Galician (Spain) galego (España)
    gsw: exports.LOCALE_KEY.DeCh,
    'gsw-CH': exports.LOCALE_KEY.DeCh,
    'gsw-FR': exports.LOCALE_KEY.DeCh,
    'gsw-LI': exports.LOCALE_KEY.DeCh,
    // 'gu', // Gujarati ગુજરાતી TODO
    // 'gu-IN', // Gujarati (India) ગુજરાતી (ભારત) TODO
    // 'guz', // Gusii Ekegusii
    // 'guz-KE', // Gusii (Kenya) Ekegusii (Kenya)
    // 'gv', // Manx Gaelg
    // 'gv-IM', // Manx (Isle of Man) Gaelg (Ellan Vannin)
    // 'ha', // Hausa Hausa TODO
    // 'ha-GH', // Hausa (Ghana) Hausa (Gana) TODO
    // 'ha-NE', // Hausa (Niger) Hausa (Nijar) TODO
    // 'ha-NG', // Hausa (Nigeria) Hausa (Najeriya) TODO
    // 'haw', // Hawaiian ʻŌlelo Hawaiʻi
    // 'haw-US', // Hawaiian (United States) ʻŌlelo Hawaiʻi (ʻAmelika Hui Pū ʻIa)
    he: exports.LOCALE_KEY.HeIl,
    'he-IL': exports.LOCALE_KEY.HeIl,
    hi: exports.LOCALE_KEY.HiIn,
    'hi-IN': exports.LOCALE_KEY.HiIn,
    hr: exports.LOCALE_KEY.HrHr,
    'hr-BA': exports.LOCALE_KEY.HrHr,
    'hr-HR': exports.LOCALE_KEY.HrHr,
    // 'hsb', // Upper Sorbian hornjoserbšćina
    // 'hsb-DE', // Upper Sorbian (Germany) hornjoserbšćina (Němska)
    hu: exports.LOCALE_KEY.HuHu,
    'hu-HU': exports.LOCALE_KEY.HuHu,
    // 'hy', // Armenian հայերեն TODO
    // 'hy-AM', // Armenian (Armenia) հայերեն (Հայաստան) TODO
    id: exports.LOCALE_KEY.IdId,
    'id-ID': exports.LOCALE_KEY.IdId,
    // 'ig', // Igbo Igbo
    // 'ig-NG', // Igbo (Nigeria) Igbo (Naịjịrịa)
    // 'ii', // Sichuan Yi ꆈꌠꉙ
    // 'ii-CN', // Sichuan Yi (China) ꆈꌠꉙ (ꍏꇩ)
    is: exports.LOCALE_KEY.IsIs,
    'is-IS': exports.LOCALE_KEY.IsIs,
    it: exports.LOCALE_KEY.It,
    'it-CH': exports.LOCALE_KEY.ItCh,
    'it-IT': exports.LOCALE_KEY.ItIt,
    'it-SM': exports.LOCALE_KEY.ItIt,
    'it-VA': exports.LOCALE_KEY.ItIt,
    ja: exports.LOCALE_KEY.Ja,
    'ja-JP': exports.LOCALE_KEY.JaJp,
    // 'jgo', // Ngomba Ndaꞌa
    // 'jgo-CM', // Ngomba (Cameroon) Ndaꞌa (Kamɛlûn)
    // 'jmc', // Machame Kimachame
    // 'jmc-TZ', // Machame (Tanzania) Kimachame (Tanzania)
    // 'ka', // Georgian ქართული TODO
    // 'ka-GE', // Georgian (Georgia) ქართული (საქართველო) TODO
    // 'kab', // Kabyle Taqbaylit
    // 'kab-DZ', // Kabyle (Algeria) Taqbaylit (Lezzayer)
    // 'kam', // Kamba Kikamba
    // 'kam-KE', // Kamba (Kenya) Kikamba (Kenya)
    // 'kde', // Makonde Chimakonde
    // 'kde-TZ', // Makonde (Tanzania) Chimakonde (Tanzania)
    // 'kea', // Kabuverdianu kabuverdianu
    // 'kea-CV', // Kabuverdianu (Cape Verde) kabuverdianu (Kabu Verdi)
    // 'khq', // Koyra Chiini Koyra ciini
    // 'khq-ML', // Koyra Chiini (Mali) Koyra ciini (Maali)
    // 'ki', // Kikuyu Gikuyu
    // 'ki-KE', // Kikuyu (Kenya) Gikuyu (Kenya)
    // 'kk', // Kazakh қазақ тілі TODO
    // 'kk-KZ', // Kazakh (Kazakhstan) қазақ тілі (Қазақстан) TODO
    // 'kkj', // Kako kakɔ
    // 'kkj-CM', // Kako (Cameroon) kakɔ (Kamɛrun)
    // 'kl', // Kalaallisut kalaallisut
    // 'kl-GL', // Kalaallisut (Greenland) kalaallisut (Kalaallit Nunaat)
    // 'kln', // Kalenjin Kalenjin
    // 'kln-KE', // Kalenjin (Kenya) Kalenjin (Emetab Kenya)
    // 'km', // Khmer ខ្មែរ
    // 'km-KH', // Khmer (Cambodia) ខ្មែរ (កម្ពុជា)
    // 'kn', // Kannada ಕನ್ನಡ TODO
    // 'kn-IN', // Kannada (India) ಕನ್ನಡ (ಭಾರತ) TODO
    ko: exports.LOCALE_KEY.KoKr,
    'ko-KP': exports.LOCALE_KEY.KoKr,
    'ko-KR': exports.LOCALE_KEY.KoKr,
    // 'kok', // Konkani कोंकणी
    // 'kok-IN', // Konkani (India) कोंकणी (भारत)
    // 'ks', // Kashmiri کٲشُر
    // 'ks-IN', // Kashmiri (India) کٲشُر (ہِنٛدوستان)
    // 'ksb', // Shambala Kishambaa
    // 'ksb-TZ', // Shambala (Tanzania) Kishambaa (Tanzania)
    // 'ksf', // Bafia rikpa
    // 'ksf-CM', // Bafia (Cameroon) rikpa (kamɛrún)
    // 'ksh', // Colognian Kölsch
    // 'ksh-DE', // Colognian (Germany) Kölsch en Doütschland
    // 'kw', // Cornish kernewek
    // 'kw-GB', // Cornish (United Kingdom) kernewek (Rywvaneth Unys)
    // 'ky', // Kyrgyz кыргызча
    // 'ky-KG', // Kyrgyz (Kyrgyzstan) кыргызча (Кыргызстан)
    // 'lag', // Langi Kɨlaangi
    // 'lag-TZ', // Langi (Tanzania) Kɨlaangi (Taansanía)
    // 'lb', // Luxembourgish Lëtzebuergesch
    // 'lb-LU', // Luxembourgish (Luxembourg) Lëtzebuergesch (Lëtzebuerg)
    // 'lg', // Ganda Luganda
    // 'lg-UG', // Ganda (Uganda) Luganda (Yuganda)
    // 'lkt', // Lakota Lakȟólʼiyapi
    // 'lkt-US', // Lakota (United States) Lakȟólʼiyapi (Mílahaŋska Tȟamákȟočhe)
    // 'ln', // Lingala lingála
    // 'ln-AO', // Lingala (Angola) lingála (Angóla)
    // 'ln-CD', // Lingala (Congo - Kinshasa) lingála (Republíki ya Kongó Demokratíki)
    // 'ln-CF', // Lingala (Central African Republic) lingála (Repibiki ya Afríka ya Káti)
    // 'ln-CG', // Lingala (Congo - Brazzaville) lingála (Kongo)
    // 'lo', // Lao ລາວ
    // 'lo-LA', // Lao (Laos) ລາວ (ລາວ)
    // 'lrc', // Northern Luri لۊری شومالی
    // 'lrc-IQ', // Northern Luri (Iraq) لۊری شومالی (IQ)
    // 'lrc-IR', // Northern Luri (Iran) لۊری شومالی (IR)
    lt: exports.LOCALE_KEY.LtLt,
    'lt-LT': exports.LOCALE_KEY.LtLt,
    // 'lu', // Luba-Katanga Tshiluba
    // 'lu-CD', // Luba-Katanga (Congo - Kinshasa) Tshiluba (Ditunga wa Kongu)
    // 'luo', // Luo Dholuo
    // 'luo-KE', // Luo (Kenya) Dholuo (Kenya)
    // 'luy', // Luyia Luluhia
    // 'luy-KE', // Luyia (Kenya) Luluhia (Kenya)
    lv: exports.LOCALE_KEY.LvLv,
    'lv-LV': exports.LOCALE_KEY.LvLv,
    // 'mas', // Masai Maa
    // 'mas-KE', // Masai (Kenya) Maa (Kenya)
    // 'mas-TZ', // Masai (Tanzania) Maa (Tansania)
    // 'mer', // Meru Kĩmĩrũ
    // 'mer-KE', // Meru (Kenya) Kĩmĩrũ (Kenya)
    // 'mfe', // Morisyen kreol morisien
    // 'mfe-MU', // Morisyen (Mauritius) kreol morisien (Moris)
    // 'mg', // Malagasy Malagasy
    // 'mg-MG', // Malagasy (Madagascar) Malagasy (Madagasikara)
    // 'mgh', // Makhuwa-Meetto Makua
    // 'mgh-MZ', // Makhuwa-Meetto (Mozambique) Makua (Umozambiki)
    // 'mgo', // Metaʼ metaʼ
    // 'mgo-CM', // Metaʼ (Cameroon) metaʼ (Kamalun)
    // 'mk', // Macedonian македонски TODO
    // 'mk-MK', // Macedonian (Macedonia) македонски (Македонија) TODO
    // 'ml', // Malayalam മലയാളം
    // 'ml-IN', // Malayalam (India) മലയാളം (ഇന്ത്യ)
    // 'mn', // Mongolian монгол TODO
    // 'mn-MN', // Mongolian (Mongolia) монгол (Монгол) TODO
    mr: exports.LOCALE_KEY.MrIn,
    'mr-IN': exports.LOCALE_KEY.MrIn,
    ms: exports.LOCALE_KEY.MsMy,
    'ms-BN': exports.LOCALE_KEY.MsMy,
    'ms-MY': exports.LOCALE_KEY.MsMy,
    'ms-SG': exports.LOCALE_KEY.MsMy,
    mt: exports.LOCALE_KEY.MtMt,
    'mt-MT': exports.LOCALE_KEY.MtMt,
    // 'mua', // Mundang MUNDAŊ
    // 'mua-CM', // Mundang (Cameroon) MUNDAŊ (kameruŋ)
    // 'my', // Burmese မြန်မာ
    // 'my-MM', // Burmese (Myanmar [Burma]) မြန်မာ (မြန်မာ)
    // 'mzn', // Mazanderani مازرونی
    // 'mzn-IR', // Mazanderani (Iran) مازرونی (ایران)
    // 'naq', // Nama Khoekhoegowab
    // 'naq-NA', // Nama (Namibia) Khoekhoegowab (Namibiab)
    nb: exports.LOCALE_KEY.NbNi,
    'nb-NO': exports.LOCALE_KEY.NbNi,
    'nb-SJ': exports.LOCALE_KEY.NbNi,
    // 'nd', // North Ndebele isiNdebele
    // 'nd-ZW', // North Ndebele (Zimbabwe) isiNdebele (Zimbabwe)
    // 'nds', // Low German nds TODO?
    // 'nds-DE', // Low German (Germany) nds (DE) TODO?
    // 'nds-NL', // Low German (Netherlands) nds (NL) Low Saxon TODO?
    // 'ne', // Nepali नेपाली
    // 'ne-IN', // Nepali (India) नेपाली (भारत)
    // 'ne-NP', // Nepali (Nepal) नेपाली (नेपाल)
    nl: exports.LOCALE_KEY.NlNl,
    'nl-AW': exports.LOCALE_KEY.NlNl,
    'nl-BE': exports.LOCALE_KEY.NlBe,
    'nl-BQ': exports.LOCALE_KEY.NlNl,
    'nl-CW': exports.LOCALE_KEY.NlNl,
    'nl-NL': exports.LOCALE_KEY.NlNl,
    'nl-SR': exports.LOCALE_KEY.NlNl,
    'nl-SX': exports.LOCALE_KEY.NlNl,
    // 'nmg', // Kwasio nmg
    // 'nmg-CM', // Kwasio (Cameroon) nmg (Kamerun)
    // 'nn', // Norwegian Nynorsk nynorsk
    // 'nn-NO', // Norwegian Nynorsk (Norway) nynorsk (Noreg)
    // 'nnh', // Ngiemboon Shwóŋò ngiembɔɔn
    // 'nnh-CM', // Ngiemboon (Cameroon) Shwóŋò ngiembɔɔn (Kàmalûm)
    // 'nus', // Nuer Thok Nath
    // 'nus-SS', // Nuer (South Sudan) Thok Nath (SS)
    // 'nyn', // Nyankole Runyankore
    // 'nyn-UG', // Nyankole (Uganda) Runyankore (Uganda)
    // 'om', // Oromo Oromoo
    // 'om-ET', // Oromo (Ethiopia) Oromoo (Itoophiyaa)
    // 'om-KE', // Oromo (Kenya) Oromoo (Keeniyaa)
    // 'or', // Odia ଓଡ଼ିଆ
    // 'or-IN', // Odia (India) ଓଡ଼ିଆ (ଭାରତ)
    // 'os', // Ossetic ирон
    // 'os-GE', // Ossetic (Georgia) ирон (Гуырдзыстон)
    // 'os-RU', // Ossetic (Russia) ирон (Уӕрӕсе)
    // 'pa', // Punjabi ਪੰਜਾਬੀ TODO
    // 'pa-Arab', // Punjabi (Arabic) پنجابی (عربی) TODO
    // 'pa-Arab-PK', // Punjabi (Arabic, Pakistan) پنجابی (عربی, پاکستان) TODO
    // 'pa-Guru', // Punjabi (Gurmukhi) ਪੰਜਾਬੀ (ਗੁਰਮੁਖੀ) TODO
    // 'pa-Guru-IN', // Punjabi (Gurmukhi, India) ਪੰਜਾਬੀ (ਗੁਰਮੁਖੀ, ਭਾਰਤ) TODO
    pl: exports.LOCALE_KEY.PlPl,
    'pl-PL': exports.LOCALE_KEY.PlPl,
    // 'ps', // Pashto پښتو TODO
    // 'ps-AF', // Pashto (Afghanistan) پښتو (افغانستان) TODO
    pt: exports.LOCALE_KEY.PtPt,
    'pt-AO': exports.LOCALE_KEY.PtPt,
    'pt-BR': exports.LOCALE_KEY.PtBr,
    'pt-CH': exports.LOCALE_KEY.PtPt,
    'pt-CV': exports.LOCALE_KEY.PtPt,
    'pt-GQ': exports.LOCALE_KEY.PtPt,
    'pt-GW': exports.LOCALE_KEY.PtPt,
    'pt-LU': exports.LOCALE_KEY.PtPt,
    'pt-MO': exports.LOCALE_KEY.PtPt,
    'pt-MZ': exports.LOCALE_KEY.PtPt,
    'pt-PT': exports.LOCALE_KEY.PtPt,
    'pt-ST': exports.LOCALE_KEY.PtPt,
    'pt-TL': exports.LOCALE_KEY.PtPt,
    // 'qu', // Quechua Runasimi
    // 'qu-BO', // Quechua (Bolivia) Runasimi (Bolivia)
    // 'qu-EC', // Quechua (Ecuador) Runasimi (Ecuador)
    // 'qu-PE', // Quechua (Peru) Runasimi (Perú)
    // 'rm', // Romansh rumantsch
    // 'rm-CH', // Romansh (Switzerland) rumantsch (Svizra)
    // 'rn', // Rundi Ikirundi
    // 'rn-BI', // Rundi (Burundi) Ikirundi (Uburundi)
    ro: exports.LOCALE_KEY.RoRo,
    'ro-MD': exports.LOCALE_KEY.RoRo,
    'ro-RO': exports.LOCALE_KEY.RoRo,
    // 'rof', // Rombo Kihorombo
    // 'rof-TZ', // Rombo (Tanzania) Kihorombo (Tanzania)
    ru: exports.LOCALE_KEY.Ru,
    'ru-BY': exports.LOCALE_KEY.Ru,
    'ru-KG': exports.LOCALE_KEY.Ru,
    'ru-KZ': exports.LOCALE_KEY.Ru,
    'ru-MD': exports.LOCALE_KEY.Ru,
    'ru-RU': exports.LOCALE_KEY.RuRu,
    'ru-UA': exports.LOCALE_KEY.Ru,
    // 'rw', // Kinyarwanda Kinyarwanda
    // 'rw-RW', // Kinyarwanda (Rwanda) Kinyarwanda (U Rwanda)
    // 'rwk', // Rwa Kiruwa
    // 'rwk-TZ', // Rwa (Tanzania) Kiruwa (Tanzania)
    // 'sah', // Sakha саха тыла
    // 'sah-RU', // Sakha (Russia) саха тыла (Арассыыйа)
    // 'saq', // Samburu Kisampur
    // 'saq-KE', // Samburu (Kenya) Kisampur (Kenya)
    // 'sbp', // Sangu Ishisangu
    // 'sbp-TZ', // Sangu (Tanzania) Ishisangu (Tansaniya)
    // 'se', // Northern Sami davvisámegiella
    // 'se-FI', // Northern Sami (Finland) davvisámegiella (Suopma)
    // 'se-NO', // Northern Sami (Norway) davvisámegiella (Norga)
    // 'se-SE', // Northern Sami (Sweden) davvisámegiella (Ruoŧŧa)
    // 'seh', // Sena sena
    // 'seh-MZ', // Sena (Mozambique) sena (Moçambique)
    // 'ses', // Koyraboro Senni Koyraboro senni
    // 'ses-ML', // Koyraboro Senni (Mali) Koyraboro senni (Maali)
    // 'sg', // Sango Sängö
    // 'sg-CF', // Sango (Central African Republic) Sängö (Ködörösêse tî Bêafrîka)
    // 'shi', // Tachelhit ⵜⴰⵛⵍⵃⵉⵜ
    // 'shi-Latn', // Tachelhit (Latin) Tashelḥiyt (Latn)
    // 'shi-Latn-MA', // Tachelhit (Latin, Morocco) Tashelḥiyt (Latn, lmɣrib)
    // 'shi-Tfng', // Tachelhit (Tifinagh) ⵜⴰⵛⵍⵃⵉⵜ (Tfng)
    // 'shi-Tfng-MA', // Tachelhit (Tifinagh, Morocco) ⵜⴰⵛⵍⵃⵉⵜ (Tfng, ⵍⵎⵖⵔⵉⴱ)
    // 'si', // Sinhala සිංහල
    // 'si-LK', // Sinhala (Sri Lanka) සිංහල (ශ්‍රී ලංකාව)
    sk: exports.LOCALE_KEY.SkSk,
    'sk-SK': exports.LOCALE_KEY.SkSk,
    sl: exports.LOCALE_KEY.SlSl,
    'sl-SI': exports.LOCALE_KEY.SlSl,
    // 'smn', // Inari Sami anarâškielâ
    // 'smn-FI', // Inari Sami (Finland) anarâškielâ (Suomâ)
    // 'sn', // Shona chiShona
    // 'sn-ZW', // Shona (Zimbabwe) chiShona (Zimbabwe)
    // 'so', // Somali Soomaali TODO
    // 'so-DJ', // Somali (Djibouti) Soomaali (Jabuuti) TODO
    // 'so-ET', // Somali (Ethiopia) Soomaali (Itoobiya) TODO
    // 'so-KE', // Somali (Kenya) Soomaali (Kiiniya) TODO
    // 'so-SO', // Somali (Somalia) Soomaali (Soomaaliya) TODO
    // 'sq', // Albanian shqip TODO
    // 'sq-AL', // Albanian (Albania) shqip (Shqipëri) TODO
    // 'sq-MK', // Albanian (Macedonia) shqip (Maqedoni) TODO
    // 'sq-XK', // Albanian (Kosovo) shqip (Kosovë) TODO
    sr: exports.LOCALE_KEY.SrLatnRs,
    // 'sr-Cyrl', // Serbian (Cyrillic) српски (ћирилица) TODO (latin or cyrillic?)
    // 'sr-Cyrl-BA', // Serbian (Cyrillic, Bosnia & Herzegovina) српски (ћирилица, Босна и Херцеговина) TODO (latin or cyrillic?)
    // 'sr-Cyrl-ME', // Serbian (Cyrillic, Montenegro) српски (ћирилица, Црна Гора) TODO (latin or cyrillic?)
    // 'sr-Cyrl-RS', // Serbian (Cyrillic, Serbia) српски (ћирилица, Србија) TODO (latin or cyrillic?)
    // 'sr-Cyrl-XK', // Serbian (Cyrillic, Kosovo) српски (ћирилица, Косово) TODO (latin or cyrillic?)
    'sr-Latn': exports.LOCALE_KEY.SrLatnRs,
    'sr-Latn-BA': exports.LOCALE_KEY.SrLatnRs,
    'sr-Latn-ME': exports.LOCALE_KEY.SrLatnRs,
    'sr-Latn-RS': exports.LOCALE_KEY.SrLatnRs,
    'sr-Latn-XK': exports.LOCALE_KEY.SrLatnRs,
    sv: exports.LOCALE_KEY.SvSe,
    'sv-AX': exports.LOCALE_KEY.SvSe,
    'sv-FI': exports.LOCALE_KEY.SvSe,
    'sv-SE': exports.LOCALE_KEY.SvSe,
    // 'sw', // Swahili Kiswahili TODO
    // 'sw-CD', // Swahili (Congo - Kinshasa) Kiswahili (Jamhuri ya Kidemokrasia ya Kongo) Congo Swahili TODO
    // 'sw-KE', // Swahili (Kenya) Kiswahili (Kenya) TODO
    // 'sw-TZ', // Swahili (Tanzania) Kiswahili (Tanzania) TODO
    // 'sw-UG', // Swahili (Uganda) Kiswahili (Uganda) TODO
    ta: exports.LOCALE_KEY.TaIn,
    'ta-IN': exports.LOCALE_KEY.TaIn,
    'ta-LK': exports.LOCALE_KEY.TaIn,
    'ta-MY': exports.LOCALE_KEY.TaIn,
    'ta-SG': exports.LOCALE_KEY.TaIn,
    // 'te', // Telugu తెలుగు TODO
    // 'te-IN', // Telugu (India) తెలుగు (భారతదేశం) TODO
    // 'teo', // Teso Kiteso
    // 'teo-KE', // Teso (Kenya) Kiteso (Kenia)
    // 'teo-UG', // Teso (Uganda) Kiteso (Uganda)
    // 'tg', // Tajik тоҷикӣ
    // 'tg-TJ', // Tajik (Tajikistan) тоҷикӣ (Тоҷикистон)
    th: exports.LOCALE_KEY.ThTh,
    'th-TH': exports.LOCALE_KEY.ThTh,
    // 'ti', // Tigrinya ትግርኛ
    // 'ti-ER', // Tigrinya (Eritrea) ትግርኛ (ኤርትራ)
    // 'ti-ET', // Tigrinya (Ethiopia) ትግርኛ (ኢትዮጵያ)
    // 'to', // Tongan lea fakatonga
    // 'to-TO', // Tongan (Tonga) lea fakatonga (Tonga)
    tr: exports.LOCALE_KEY.TrTr,
    'tr-CY': exports.LOCALE_KEY.TrTr,
    'tr-TR': exports.LOCALE_KEY.TrTr,
    // 'tt', // Tatar татар
    // 'tt-RU', // Tatar (Russia) татар (Россия)
    // 'twq', // Tasawaq Tasawaq senni
    // 'twq-NE', // Tasawaq (Niger) Tasawaq senni (Nižer)
    // 'tzm', // Central Atlas Tamazight Tamaziɣt n laṭlaṣ
    // 'tzm-MA', // Central Atlas Tamazight (Morocco) Tamaziɣt n laṭlaṣ (Meṛṛuk)
    // 'ug', // Uyghur ئۇيغۇرچە
    // 'ug-CN', // Uyghur (China) ئۇيغۇرچە (جۇڭگو)
    uk: exports.LOCALE_KEY.UkUa,
    'uk-UA': exports.LOCALE_KEY.UkUa,
    // 'ur', // Urdu اردو TODO
    // 'ur-IN', // Urdu (India) اردو (بھارت) TODO
    // 'ur-PK', // Urdu (Pakistan) اردو (پاکستان) TODO
    // 'uz', // Uzbek o‘zbek TODO
    // 'uz-Arab', // Uzbek (Arabic) اوزبیک (عربی) TODO
    // 'uz-Arab-AF', // Uzbek (Arabic, Afghanistan) اوزبیک (عربی, افغانستان) TODO
    // 'uz-Cyrl', // Uzbek (Cyrillic) ўзбекча (Кирил) TODO
    // 'uz-Cyrl-UZ', // Uzbek (Cyrillic, Uzbekistan) ўзбекча (Кирил, Ўзбекистон) TODO
    // 'uz-Latn', // Uzbek (Latin) o‘zbek (lotin) TODO
    // 'uz-Latn-UZ', // Uzbek (Latin, Uzbekistan) o‘zbek (lotin, Oʻzbekiston) TODO
    // 'vai', // Vai ꕙꔤ
    // 'vai-Latn', // Vai (Latin) Vai (Latn)
    // 'vai-Latn-LR', // Vai (Latin, Liberia) Vai (Latn, Laibhiya)
    // 'vai-Vaii', // Vai (Vai) ꕙꔤ (Vaii)
    // 'vai-Vaii-LR', // Vai (Vai, Liberia) ꕙꔤ (Vaii, ꕞꔤꔫꕩ)
    vi: exports.LOCALE_KEY.ViVn,
    'vi-VN': exports.LOCALE_KEY.ViVn,
    // 'vun', // Vunjo Kyivunjo
    // 'vun-TZ', // Vunjo (Tanzania) Kyivunjo (Tanzania)
    // 'wae', // Walser Walser
    // 'wae-CH', // Walser (Switzerland) Walser (Schwiz)
    // 'wo', // Wolof Wolof
    // 'wo-SN', // Wolof (Senegal) Wolof (Senegaal)
    // 'xog', // Soga Olusoga
    // 'xog-UG', // Soga (Uganda) Olusoga (Yuganda)
    // 'yav', // Yangben nuasue
    // 'yav-CM', // Yangben (Cameroon) nuasue (Kemelún)
    // 'yi', // Yiddish ייִדיש
    // 'yi-001', // Yiddish (World) ייִדיש (וועלט)
    // 'yo', // Yoruba Èdè Yorùbá
    // 'yo-BJ', // Yoruba (Benin) Èdè Yorùbá (Orílɛ́ède Bɛ̀nɛ̀)
    // 'yo-NG', // Yoruba (Nigeria) Èdè Yorùbá (Orílẹ́ède Nàìjíríà)
    yue: exports.LOCALE_KEY.ZhHk,
    'yue-Hans': exports.LOCALE_KEY.ZhCn,
    'yue-Hans-CN': exports.LOCALE_KEY.ZhCn,
    'yue-Hant': exports.LOCALE_KEY.ZhHk,
    'yue-Hant-HK': exports.LOCALE_KEY.ZhHk,
    // 'zgh', // Standard Moroccan Tamazight ⵜⴰⵎⴰⵣⵉⵖⵜ
    // 'zgh-MA', // Standard Moroccan Tamazight (Morocco) ⵜⴰⵎⴰⵣⵉⵖⵜ (ⵍⵎⵖⵔⵉⴱ)
    zh: exports.LOCALE_KEY.ZhCn,
    'zh-Hans': exports.LOCALE_KEY.ZhCn,
    'zh-Hans-CN': exports.LOCALE_KEY.ZhCn,
    'zh-Hans-HK': exports.LOCALE_KEY.ZhCn,
    'zh-Hans-MO': exports.LOCALE_KEY.ZhCn,
    'zh-Hans-SG': exports.LOCALE_KEY.ZhCn,
    'zh-Hant': exports.LOCALE_KEY.ZhHk,
    'zh-Hant-HK': exports.LOCALE_KEY.ZhHk,
    'zh-Hant-MO': exports.LOCALE_KEY.ZhHk,
    'zh-Hant-TW': exports.LOCALE_KEY.ZhHk,
    zu: exports.LOCALE_KEY.ZuZa,
    'zu-ZA': exports.LOCALE_KEY.ZuZa, // Zulu (South Africa) isiZulu (iNingizimu Afrika)
};
/**
 * Native language names, used to render options to users
 * Language options for end-users should be written in own language
 */
exports.NATIVE_LANGUAGE_NAMES = {
    /* English */
    [exports.LOCALE_KEY.En]: 'English',
    /* Arabic */
    [exports.LOCALE_KEY.Ar]: 'العربية',
    /* French */
    [exports.LOCALE_KEY.Fr]: 'Français',
    /* German */
    [exports.LOCALE_KEY.De]: 'Deutsch',
    /* Spanish */
    [exports.LOCALE_KEY.Es]: 'Español',
    /* Italian */
    [exports.LOCALE_KEY.It]: 'Italiano',
    /* Japanese */
    [exports.LOCALE_KEY.Ja]: '日本語',
    /* Russian */
    [exports.LOCALE_KEY.Ru]: 'Русский язык',
    /* Arabic UAE */
    [exports.LOCALE_KEY.ArAe]: 'العربية (الإمارات العربية المتحدة)',
    /* French */
    [exports.LOCALE_KEY.FrFr]: 'Français (France)',
    /* German */
    [exports.LOCALE_KEY.DeDe]: 'Deutsch (Deutschland)',
    /* Italian */
    [exports.LOCALE_KEY.ItIt]: 'Italiano (Italia)',
    /* Afrikaans */
    [exports.LOCALE_KEY.AfZz]: 'Afrikaans',
    /* Bulgarian */
    [exports.LOCALE_KEY.BgBg]: 'български',
    /* Chinese Simplified */
    [exports.LOCALE_KEY.ZhCn]: '汉语',
    /* Croatian */
    [exports.LOCALE_KEY.HrHr]: 'Hrvatski',
    /* Czech */
    [exports.LOCALE_KEY.CsCz]: 'Čeština',
    /* Danish */
    [exports.LOCALE_KEY.DaDk]: 'Dansk',
    /* English (UK) */
    [exports.LOCALE_KEY.EnGb]: 'English (UK)',
    /* English (Canada) */
    [exports.LOCALE_KEY.EnCa]: 'English (Canada)',
    /* English (UAE) */
    [exports.LOCALE_KEY.EnAe]: 'English (UAE)',
    /* Finnish */
    [exports.LOCALE_KEY.FiFi]: 'Suomi',
    /* Greek */
    [exports.LOCALE_KEY.ElGr]: 'ελληνικά',
    /* Hindi */
    [exports.LOCALE_KEY.HiIn]: 'हिन्दी',
    /* Hungarian */
    [exports.LOCALE_KEY.HuHu]: 'Magyar',
    /* Indonesian */
    [exports.LOCALE_KEY.IdId]: 'Bahasa Indonesia',
    /* Japanese */
    [exports.LOCALE_KEY.JaJp]: '日本語',
    /* Korean */
    [exports.LOCALE_KEY.KoKr]: '한국어',
    /* Lithuanian */
    [exports.LOCALE_KEY.LtLt]: 'Lietuvių',
    /* Malay */
    [exports.LOCALE_KEY.MsMy]: 'Bahasa Melayu',
    /* Marathi */
    [exports.LOCALE_KEY.MrIn]: 'मराठी',
    /* Norwegian Bokmål */
    [exports.LOCALE_KEY.NbNi]: 'Bokmål',
    /* Polish */
    [exports.LOCALE_KEY.PlPl]: 'Polski',
    /* Portuguese (Brazil) */
    [exports.LOCALE_KEY.PtBr]: 'Português (Brasil)',
    /* Portuguese (Portugal) */
    [exports.LOCALE_KEY.PtPt]: 'Português (Portugal)',
    /* Romanian */
    [exports.LOCALE_KEY.RoRo]: 'Română',
    /* Russian */
    [exports.LOCALE_KEY.RuRu]: 'Русский язык',
    /* Latn-Serbian (Latin) */
    [exports.LOCALE_KEY.SrLatnRs]: 'Srpski',
    /* Swedish */
    [exports.LOCALE_KEY.SvSe]: 'Svenska',
    /* Tamil */
    [exports.LOCALE_KEY.TaIn]: 'தமிழ்',
    /* Thai */
    [exports.LOCALE_KEY.ThTh]: 'ภาษาไทย',
    /* Turkish */
    [exports.LOCALE_KEY.TrTr]: 'Türkçe',
    /* Ukrainian */
    [exports.LOCALE_KEY.UkUa]: 'українська мова',
    /* Vietnamese */
    [exports.LOCALE_KEY.ViVn]: 'Tiếng Việt',
    /* Zulu */
    [exports.LOCALE_KEY.ZuZa]: 'isiZulu',
    /* USA */
    [exports.LOCALE_KEY.EnUs]: 'English (US)',
    /* Australia */
    [exports.LOCALE_KEY.EnAu]: 'English (Australia)',
    /* Belgium */
    [exports.LOCALE_KEY.FrBe]: 'Français (Belgique)',
    /* Quebec */
    [exports.LOCALE_KEY.FrCa]: 'Français (Québec)',
    /* Ireland */
    [exports.LOCALE_KEY.EnIe]: 'English (Ireland)',
    /* Dutch */
    [exports.LOCALE_KEY.NlNl]: 'Nederlands',
    /* Dutch (Belgium) */
    [exports.LOCALE_KEY.NlBe]: 'Nederlands (België)',
    /* Spanish (Castilian) */
    [exports.LOCALE_KEY.EsEs]: 'Español (Castellano)',
    /* Spanish (Latin America & Caribbean) */
    [exports.LOCALE_KEY.Es419]: 'Español (América Latina)',
    /* Chinese (Traditional) */
    [exports.LOCALE_KEY.ZhHk]: '漢語',
    /** Austrian German */
    [exports.LOCALE_KEY.DeAt]: 'Österreichisches Standarddeutsch,',
    /** Swiss German */
    [exports.LOCALE_KEY.DeCh]: 'Schwiizerdütsch',
    /** Swiss Italian */
    [exports.LOCALE_KEY.ItCh]: 'Dialetto Svizzero',
    /** French (Switzerland) */
    [exports.LOCALE_KEY.FrCh]: 'Français de Suisse',
    /** Hebrew (Israel) */
    [exports.LOCALE_KEY.HeIl]: 'עִבְרִית',
    /* New Zealand */
    [exports.LOCALE_KEY.EnNz]: 'English (New Zealand)',
    /** Estonian (Estonia) */
    [exports.LOCALE_KEY.EtEe]: 'Eesti',
    /** Icelandic (Iceland) */
    [exports.LOCALE_KEY.IsIs]: 'Íslenska',
    /** Latvian (Latvia) */
    [exports.LOCALE_KEY.LvLv]: 'Latviešu',
    /** Maltese (Malta) */
    [exports.LOCALE_KEY.MtMt]: 'Malti',
    /** Slovak (Slovakia) */
    [exports.LOCALE_KEY.SkSk]: 'Slovenčina',
    /** Slovenian (Slovenia) */
    [exports.LOCALE_KEY.SlSl]: 'Slovenščina',
};
/* eslint-enable max-lines */
//# sourceMappingURL=enums.js.map